module.exports = __webpack_public_path__ + "img/9 filters B-01.9540948a.png";